import { Box, Tab, Tabs } from '@mui/material';
import { ConnectAccountManagement, ConnectBalances, ConnectPayments, ConnectPayoutsList } from '@stripe/react-connect-js';
import React, { useState } from 'react';
import { isClubOwner, isCoach } from '../../util/UserRoles';
import OfflinePayment from './OfflinePayment';
import OnlinePayment from './OnlinePayment';
import { Privileges } from '../../util/PrivilegeConstants';



const PayoutDashboard = ({ privileges }) => {
    const [value, setValue] = useState(0);
    const handleTabChange = (event, newValue) => {
        setValue(newValue)

    }
    return (
        <div className='user-admin-dash-container'>
            {privileges?.MANAGE_PAYOUT?.includes(Privileges.VIEW) &&
                <div data-testid="user-admin-dash-balance" className="user-admin-dash-balance">
                    <ConnectBalances />
                </div>}
            {privileges?.MANAGE_TRANSACTION?.includes(Privileges.VIEW) &&
                <>
                    <div data-testid="user-admin-dash-money-movement" className="user-admin-dash-money-movement">
                        <h1>Money Movement</h1>
                        <div className='money-nove-tabs'>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs className='money_movement-tabs' value={value} onChange={handleTabChange} aria-label="basic tabs example">
                                    <Tab className='money-move-tab'
                                        sx={{ fontWeight: 600 }} label="Online Payments" />
                                    <Tab
                                        className='money-move-tab'
                                        sx={{ fontWeight: 600 }} label="Offline Paymnets" />
                                    <Tab
                                        className='money-move-tab'
                                        sx={{ fontWeight: 600 }} label="Payout" />
                                </Tabs>
                            </Box>
                        </div>
                    </div>
                    <div className="user-admin-dash-movment-list">
                        {value == 0 && <OnlinePayment />}
                        {value == 1 && <OfflinePayment />}
                        {value == 2 && <ConnectPayoutsList />}
                    </div>
                </>}

            {(privileges?.MANAGE_ACCOUNT?.includes(Privileges.VIEW)) &&
                <div data-testid="user-admin-dash-management" className="user-admin-dash-management">
                    <ConnectAccountManagement />
                </div>}
        </div>
    )
}

export default PayoutDashboard